import { upperCaseFirst } from "./utils";
/* eslint-disable */
const defaultMsgConfig = {
  format: "block", // block, list
  html: true,
  mb: 2, // margin-bottom on items
  capitalize: true,
  prepend: null,
  append: null,
};

const getErrorMsg = (errors, cfg = {}) => {
  let config = { ...defaultMsgConfig, ...cfg };
  return config.html
    ? errorMsgHtml(errors, config)
    : errorMsgText(errors, config);
};

const errorMsgText = (errors, config) => {
  let output = [];
  for (const key in errors) {
    output.push(errors[key]);
  }
  return output.join(". ");
};

const errorMsgHtml = (errors, config) => {
  const block = () => {
    let output = "";
    for (const key in errors) {
      const items = errors[key];
      for (let x = 0; x < items.length; x++) {
        const msg = items[x];
        output += `${output ? ", " : ""} ${
          config.prepend ? config.prepend : ""
        }${config.capitalize ? msg : msg}${config.append ? config.append : ""}`;
      }
    }
    return output;
  };

  const list = () => {
    const items = Object.keys(errors).map((key) => {
      const parts = errors[key];
      return parts.map((msg) => `<li>${msg}</li>`);
    });

    return ["<ul>", ...items, "</ul>"];
  };

  switch (config.format) {
    case "list":
      return list().join(" ");
    case "block":
    default:
      return block();
  }
};

const getErrorsSubject = (errors) => {
  if (Object.keys(errors).length) {
    let i = 1;
    for (const key in errors) {
      if (i === 1)
        return `<span class="text-capitalize">${key.replace(/_/g, " ")}</span>`;
    }
  }
};
const getErrorsSubjectText = (errors) => {
  if (Object.keys(errors).length) {
    let i = 1;
    for (const key in errors) {
      if (i === 1) return `${upperCaseFirst(key.replace(/_/g, " "))}`;
    }
  }
};

export const errors = (errors) => {
  return {
    subject(config) {
      return getErrorsSubject(errors, config);
    },
    msg(config) {
      return getErrorMsg(errors, config);
    },
    subjectText(config) {
      return getErrorsSubjectText(errors, config);
    },
  };
};
